import apiClient from '../api';

// export const getAccountDocuments = async (accountId) => {
//     try {
//         const response = await apiClient.get(`/api/accountdocuments/${accountId}/documents`);
//         return response.data;
//     } catch (error) {
//         // console.error('Erreur lors de la récupération des documents:', error);
//         throw new Error('Impossible de charger les documents');
//     }
// };

// Fonction pour ouvrir le document directement dans le navigateur
// Ouvrir le document
// export const openDocument = (accountId, fileName, isPdf = false) => {
//     const downloadUrl = `/api/accountdocuments/${accountId}/documents/${fileName}/download`;
//     if (isPdf) {
//         // Ouvre le PDF dans un nouvel onglet
//         window.open(downloadUrl, '_blank', 'noopener,noreferrer');
//     } else {
//         // Pour les autres fichiers (images, Word, Excel…), le navigateur téléchargera correctement
//         const link = document.createElement('a');
//         link.href = downloadUrl;
//         link.download = fileName;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     }
// };


// // Fonction pour télécharger le document
// export const downloadDocument = async (url, fileName) => {
//     try {
//         const response = await fetch(url);
//         const blob = await response.blob();
//         const downloadUrl = window.URL.createObjectURL(blob);
//         const link = document.createElement('a');
//         link.href = downloadUrl;
//         link.download = fileName || 'document';
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(downloadUrl);
//     } catch (error) {
//         // console.error('Erreur lors du téléchargement:', error);
//         throw new Error('Impossible de télécharger le document');
//     }
// };

// Service dédié pour récupérer les URLs d'images signées
export const getAccountImages = async (accountId) => {
    try {
        const response = await apiClient.get(`/api/accountdocuments/${accountId}/documents`);
        const documents = response.data;
        
        const images = documents.filter(doc => 
            doc.type === 'PICTURE' || doc.type === 'LOGO'
        );
        
        return images;
    } catch (error) {
        console.error('Erreur lors de la récupération des images:', error);
        throw new Error('Impossible de charger les images');
    }
};

export const getAccountImageUrl = async (accountId, imageType = 'auto') => {
    try {
        const images = await getAccountImages(accountId);
        
        if (images.length === 0) return null;
        
        if (imageType === 'auto') {
            return images[0].url;
        }
        
        const image = images.find(img => img.type === imageType);
        return image ? image.url : null;
        
    } catch (error) {
        console.error('Erreur getAccountImageUrl:', error);
        return null;
    }
};

export const getAccountDocuments = async (accountId) => {
    try {
        const response = await apiClient.get(`/api/accountdocuments/${accountId}/documents`);
        // ✅ AJOUTER accountId à chaque document
        return response.data.map(doc => ({
            ...doc,
            accountId: accountId
        }));
    } catch (error) {
        throw new Error('Impossible de charger les documents');
    }
};

// ✅ FONCTION MODIFIÉE POUR UTILISER LE PROXY AVEC LA BONNE baseURL
export const openDocument = async (accountId, document) => {
    try {
        const isPdf = document.fileName.toLowerCase().includes('.pdf');
        const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(document.fileName);
        
        if (isPdf || isImage) {
            // ✅ CONSTRUIRE L'URL COMPLÈTE AVEC LA baseURL
            const baseURL = apiClient.defaults.baseURL || '';
            const proxyUrl = `${baseURL}/api/accountdocuments/${accountId}/view/${document.container}/${encodeURIComponent(document.fileName)}`;
            window.open(proxyUrl, '_blank', 'noopener,noreferrer');
        } else {
            // Pour les autres fichiers, utiliser l'URL signée directe
            window.open(document.url, '_blank', 'noopener,noreferrer');
        }
    } catch (error) {
        throw new Error('Impossible d\'ouvrir le document');
    }
};

export const downloadDocument = async (url, fileName) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName || 'document';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        throw new Error('Impossible de télécharger le document');
    }
};